import TrackElements from '@capsule/track-elements'
import {
	setBatchEvents,
	setBatchEventsArticleWall
} from 'front/shared/assets/scripts/setBatchEvents'
import PmcBridge from 'shared/services/pmc-bridge'

export default class ArticleWall {
	wallArticle: HTMLElement | null
	paidArticle: HTMLElement | null
	wrapperWall: HTMLElement | null
	PMCBrige: PmcBridge
	isUserSubscribed: boolean
	subscription: string[]
	trackElements: TrackElements | null

	constructor() {
		this.wallArticle = document.getElementById('articleWall')
		this.paidArticle = document.getElementById('articleWall-paid')
		this.wrapperWall = document.getElementById('articleWall-wrapper')
		this.PMCBrige = new PmcBridge()
		this.isUserSubscribed = false
		this.subscription = []
		this.trackElements = null
	}

	async init() {
		this.isUserSubscribed = await this.PMCBrige.hasSubscription()
		this.subscription = await this.PMCBrige.getAllSubscriptions()

		if (this.isUserSubscribed) {
			this.unlockArticle()
		} else {
			this.addTrackingWall()
		}

		setBatchEvents(() => setBatchEventsArticleWall(this.isUserSubscribed, this.subscription))
	}

	unlockArticle() {
		this.wallArticle?.classList.add('unlocked')
		this.paidArticle?.removeAttribute('hidden')
		this.wrapperWall?.setAttribute('hidden', '')
	}

	addTrackingWall() {
		const wallButtonOffer = document.getElementById('wall-button-offer')

		this.trackElements = new TrackElements([
			{
				element: this.wallArticle,
				display: {
					event: 'button_display',
					button_name: 'cta-paywall',
					button_label: "Je découvre l'offre"
				}
			},
			{
				element: wallButtonOffer,
				click: {
					event: 'button_click',
					button_name: 'cta-paywall',
					button_label: "Je découvre l'offre"
				}
			}
		])
		this.trackElements.init()
	}
}
